import * as customerSagas from './customerSaga';

const watchers = [
  customerSagas.watchOnSuccessCustomerSearch(),
  customerSagas.watchDefaultAddressChange(),
];

export default watchers;
